<script setup>
import { ref, computed } from "vue";
import { useGlobalStore } from "@stores/global.js";
import { useShopifyStore } from "@stores/shopify.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import Product from "@components/cards/Product.vue";
import ArrowLeft from "@components/icons/ArrowLeft.vue";
import ArrowRight from "@components/icons/ArrowRight.vue";
import "swiper/css";

const global = useGlobalStore();
const shopify = useShopifyStore();

const slider = ref({});
const breakpoints = {
	0: {
		slidesPerView: 1.5,
		spaceBetween: 8,
	},
	768: {
		slidesPerView: 2.5,
		spaceBetween: 8,
	},
	1024: {
		slidesPerView: 3.5,
		spaceBetween: 8,
	},
};

const onSwiper = (swiper) => {
	slider.value = swiper;
};

const products = computed(() => shopify.homepageFeaturedProducts);
</script>

<template>
	<section v-if="products.length > 0" class="overflow-hidden py-48 lg:py-80">
		<div class="container">
			<div class="mb-24 lg:mb-48">
				<h2 class="h2 font-primary-condensed text-center">What's new</h2>
			</div>
			<div class="relative isolate">
				<Swiper
					@swiper="onSwiper"
					:breakpoints="breakpoints"
					class="overflow-visible!"
				>
					<SwiperSlide v-for="product in products" :key="product.id">
						<div
							@mouseenter="
								if (global.pointerFine) {
									global.setHeaderTheme(
										product.theme?.background,
										product.theme?.accent,
										product.theme?.surface,
									);
								}
							"
							@mouseleave="global.setHeaderTheme(null, null, null)"
						>
							<Product :product="product" />
						</div>
					</SwiperSlide>
				</Swiper>
				<button
					class="group absolute top-1/2 -left-24 z-10 hidden size-48 -translate-y-1/2 items-center justify-center rounded-full bg-[var(--theme-surface)] text-[var(--theme-background)] transition-all md:flex"
					@click.stop="slider.slidePrev()"
					aria-label="Previous image"
					v-if="!slider.isBeginning"
				>
					<ArrowLeft class="size-14 group-hover:opacity-75" />
				</button>
				<button
					class="group absolute top-1/2 -right-24 z-10 hidden size-48 -translate-y-1/2 items-center justify-center rounded-full bg-[var(--theme-surface)] text-[var(--theme-background)] transition-all md:flex"
					@click.stop="slider.slideNext()"
					aria-label="Next image"
					v-if="!slider.isEnd"
				>
					<ArrowRight class="size-14 group-hover:opacity-75" />
				</button>
			</div>
		</div>
	</section>
</template>
